var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "c-menu_item",
        !_vm.$attrs.isFixedMenu &&
        (_vm.$attrs.isShowTooltip !== undefined
          ? _vm.$attrs.isShowTooltip
          : true)
          ? "is-narrow_menu_item"
          : "",
      ],
    },
    [
      !_vm.$attrs.isFixedMenu &&
      (_vm.$attrs.isShowTooltip !== undefined
        ? _vm.$attrs.isShowTooltip
        : true) &&
      _vm.$slots.title
        ? _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                placement: "top",
                disabled:
                  _vm.$attrs.isDisabled != undefined
                    ? _vm.$attrs.isDisabled
                    : false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _vm.isUseCustomStr
                    ? _vm._t("title")
                    : _c("span", [_vm._v(_vm._s(_vm.customStr))]),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "tooltip_item_wrap" },
                [_vm._t("default"), _vm._t("title")],
                2
              ),
            ]
          )
        : [
            _c(
              "div",
              {
                staticClass: "defaultDisplayFlex",
                staticStyle: { overflow: "hidden" },
              },
              [_vm._t("default"), _vm._t("title")],
              2
            ),
            _c(
              "div",
              { staticClass: "defaultDisplayFlex" },
              [_vm._t("num"), _vm._t("operate"), _vm._t("arrow")],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }